import styled from 'styled-components';
import Screen from '../../../../shared/utils/screen';

const DescriptionChannelTitleContainer = styled.div<React.CSSProperties>`
  display: flex;
  flex-direction: row;
  line-height: ${36 * Screen.widthRatio}px;
`;

export default DescriptionChannelTitleContainer;
